export class ConfigEvr {
	NomApp: string = 'Utool V0.1';
	tokenApp: string = '08ea8446d32b86ffda06e631320ca431';

	urlEspaceAdmin: string = 'https://admin.utool.fr/';
	urlEspaceDistributeur: string = 'https://distributeur.utool.fr/';

	urlBase: string;
	authPage: string;
	appPage: string;

	http: string = 'http://';

	constructor(http: string) {
		this.http = http;
	}

	// Configuration envirement dev
	configApp_dev() {
		this.urlBase = 'http://www.girafe.fr/';
		this.authPage = '/login';
		this.appPage = '/app';
	}


	// Configuration envirement dev alpha
	configApp_alpha() {
		this.urlBase = this.http + 'apialpha.utool.fr/';
		this.authPage = '/login';
		this.appPage = '/app';
	}


	// Configuration envirement prod beta
	configApp_beta() {
		this.urlBase = this.http + 'apibeta.utool.fr/';
		this.authPage = '/login';
		this.appPage = '/app';
	}


	// Configuration envirement prod
	configApp_prod() {
		this.urlBase = this.http + 'api.utool.fr/';
		this.authPage = '/login';
		this.appPage = '/app';
	}


	// Configuration envirement utoolAdmin
	configApp_admin(version : string) {
		switch (version) {
			case 'alpha':
				this.urlBase = this.http + 'apialpha.utool.fr/';
				break;

			case 'beta':
				this.urlBase = this.http + 'apibeta.utool.fr/';
				break;

			case 'prod':
				this.urlBase = this.http + 'api.utool.fr/';
				break;
		}

		this.authPage = '/login';
		this.appPage = '/app';
	}


	// Configuration envirement utoolDistrib
	configApp_distributeur(version : string) {

		switch (version) {
			case 'alpha':
				this.urlBase = this.http + 'apialpha.utool.fr/';
				break;

			case 'beta':
				this.urlBase = this.http + 'apibeta.utool.fr/';
				break;

			case 'prod':
				this.urlBase = this.http + 'api.utool.fr/';
				break;
		}

		this.authPage = '/login';
		this.appPage = '/app';
	}
}

